function Services() {
  return (
    <>
      <div id="services" className="flex flex-col box-border my-5 px-8 pt-12 text-white">
        <div className="text-center">
          <h1 className="m-0 text-xl font-bold mb-5">Services</h1>
        </div>
        <div className="flex flex-col gap-30">
          <div className="flex md:flex-row sm:flex-col lg:gap-30 sm:15  items-center justify-evenly lg:mb-10 sm:mb-0">
            <div>
              <div className="flex flex-col justify-center items-center lg:h-40 sm:h-36  lg:w-96 sm:w-72 bg-gray-800 m-4 rounded-lg">
                <img src="web-development.png" alt="WEB" />
                <h3>Web Development</h3>
              </div>
            </div>
            <div>
              <div className="flex flex-col justify-center items-center lg:h-40 sm:h-36  lg:w-96 sm:w-72 bg-gray-800 m-4 rounded-lg">
                <img src="responsive-design.png" alt="Responsive-design" />
                <h3>Responsive Design</h3>
              </div>
            </div>
          </div>
          <div className="flex md:flex-row sm:flex-col justify-evenly items-center">
            <div>
              <div className="flex flex-col justify-center items-center lg:h-40 sm:h-36  lg:w-96 sm:w-72 bg-gray-800 m-4 rounded-lg">
                <img src="v-control.png" alt="Version-control" />
                <h3>Version Control/Git Management</h3>
              </div>
            </div>
            <div>
              <div className="flex flex-col justify-center items-center lg:h-40 sm:h-36  lg:w-96 sm:w-72 bg-gray-800 m-4 rounded-lg">
                <img src="deployment.png" alt="Deployment" />
                <h3>Deployment and Maintenance</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Services;
